












































































































































































































































































































































































































































































































































































import Vue from "vue";
import Component from "vue-class-component";
import func from "@/ts/FormFunctions";
import ErrorMessages from "@/ts/constants/PermitsErrorMessages";
import fieldData, { RecyclingFacility } from "@/ts/FormData";
import builder, { IVueStateCollection } from "@/ts/FormBuilder";
import { ISelectItemVueModel } from "@/ts/models/ISelectItemVueModel";
import { IRecyclingFacilityApplicationVueModel } from "@/ts/models/IRecyclingFacilityApplicationVueModel";

@Component({
    props: {
        form: {
            type: Object as () => IRecyclingFacilityApplicationVueModel
        },
        vueStates: {
            type: Object as () => IVueStateCollection
        },
        isReadOnly: {
            type: Boolean
        }
    }
})
export default class RecyclingFacilityDailyOperations extends Vue {
    name: string = "RecyclingFacilityDailyOperations";
    title: string = "";
    index: number = NaN;

    unitsOfMeasure = fieldData.unitsOfMeasure;
    errorMsgs = ErrorMessages;

    mounted(): void {
        this.initializeComponent("DailyOperations");
        this.initializeStaticData();
        this.initializeListeners();
    }

    private initializeComponent(routeName: string): void {
        this.index = builder.getIndexByVueState(this.$props.vueStates.views, routeName);
        this.title = this.$props.vueStates.views[this.index].name;

        this.$emit("update:title", this.title);
        this.$emit("update:currentIndex", this.index);

        this.$watch("hasErrors", (n, o) => {
            this.$props.vueStates.views[this.index].error = this.hasErrors;
        }, { immediate: true });

        this.$props.vueStates.views[this.index].visited = true;
    }

    private initializeStaticData(): void {
        if (this.$props.form.acceptedSources.length === 0) {
            this.$props.form.acceptedSources = fieldData.acceptedSources;
        }

        if (this.$props.form.materialSortingMethods.length === 0) {
            this.$props.form.materialSortingMethods = RecyclingFacility.materialSortingMethods;
        }

        if (this.$props.form.materialProcessingMethods.length === 0) {
            this.$props.form.materialProcessingMethods = RecyclingFacility.materialProcessingMethods;
        }

        if (this.$props.form.odorPreventionMethods.length === 0) {
            this.$props.form.odorPreventionMethods = fieldData.odorPreventionMethods;
        }

        if (this.$props.form.noisePreventionMethods.length === 0) {
            this.$props.form.noisePreventionMethods = fieldData.noisePreventionMethods;
        }

        if (this.$props.form.dustPreventionMethods.length === 0) {
            this.$props.form.dustPreventionMethods = fieldData.dustPreventionMethods;
        }

        if (this.$props.form.cleaningProcedures.length === 0) {
            this.$props.form.cleaningProcedures = fieldData.cleaningProcedures;
        }
        this.$props.form.isUnauthorizedMaterials = this.$props.form.isUnauthorizedMaterials == "" ? "" : this.$props.form.isUnauthorizedMaterials;
        this.$props.form.isReturnedMaterialsRecorded = this.$props.form.isReturnedMaterialsRecorded == "" ? "" : this.$props.form.isReturnedMaterialsRecorded;
        this.$props.form.isAcceptanceLogMaintained = this.$props.form.isAcceptanceLogMaintained == "" ? "" : this.$props.form.isAcceptanceLogMaintained;
        this.$props.form.isDocumentsUnauthorizedWaste = this.$props.form.isDocumentsUnauthorizedWaste == "" ? "" : this.$props.form.isDocumentsUnauthorizedWaste;
    }

    private initializeListeners(): void {
        this.$watch("isOtherSourcesSelected", (n, o) => {
            if (!n) {
                this.$props.form.acceptedSourceDescription = null;
            }
        }, { immediate: true });

        this.$watch("isOtherProcessMethodSelected", (n, o) => {
            if (!n) {
                this.$props.form.materialProcessingDescription = null;
            }
        }, { immediate: true });

        this.$watch("isOtherOdorPreventionSelected", (n, o) => {
            if (!n) {
                this.$props.form.odorPreventionDescription = null;
            }
        }, { immediate: true });

        this.$watch("isOtherNoisePreventionSelected", (n, o) => {
            if (!n) {
                this.$props.form.noisePreventionDescription = null;
            }
        }, { immediate: true });

        this.$watch("isOtherDustPreventionSelected", (n, o) => {
            if (!n) {
                this.$props.form.dustPreventionDescription = null;
            }
        }, { immediate: true });

        this.$watch("isOtherCleaningSelected", (n, o) => {
            if (!n) {
                this.$props.form.cleaningProcedureDescription = null;
            }
        }, { immediate: true });
    }

    get isOtherSourcesSelected(): boolean {
        return this.getIsOtherOptionSelected(this.$props.form.acceptedSources);
    }

    get isOtherProcessMethodSelected(): boolean {
        return this.getIsOtherOptionSelected(this.$props.form.materialProcessingMethods);
    }

    get isOtherOdorPreventionSelected(): boolean {
        return this.getIsOtherOptionSelected(this.$props.form.odorPreventionMethods);
    }

    get isOtherNoisePreventionSelected(): boolean {
        return this.getIsOtherOptionSelected(this.$props.form.noisePreventionMethods);
    }

    get isOtherDustPreventionSelected(): boolean {
        return this.getIsOtherOptionSelected(this.$props.form.dustPreventionMethods);
    }

    get isOtherCleaningSelected(): boolean {
        return this.getIsOtherOptionSelected(this.$props.form.cleaningProcedures);
    }


    get isMaterialCapacityError(): boolean {
        return func.isNullOrEmpty(this.$props.form.materialCapacity) || (this.$props.form.materialCapacity as number)*1 <= 0;
    }

    get isOtherSourcesError(): boolean {
        return this.isOtherSourcesSelected && func.isNullOrEmpty(this.$props.form.acceptedSourceDescription);
    }

    get isMaterialTransportError(): boolean {
        return func.isNullOrEmpty(this.$props.form.materialTransportationDescription);
    }

    get isOtherProcessMethodError(): boolean {
        return this.isOtherProcessMethodSelected && func.isNullOrEmpty(this.$props.form.materialProcessingDescription);
    }

    get isEquipmentMachineryError(): boolean {
        return func.isNullOrEmpty(this.$props.form.equipmentMachineryDescription);
    }

    get isOtherOdorPreventionError(): boolean {
        return this.isOtherOdorPreventionSelected && func.isNullOrEmpty(this.$props.form.odorPreventionDescription);
    }

    get isOtherNoisePreventionError(): boolean {
        return this.isOtherNoisePreventionSelected && func.isNullOrEmpty(this.$props.form.noisePreventionDescription);
    }

    get isOtherDustPreventionError(): boolean {
        return this.isOtherDustPreventionSelected && func.isNullOrEmpty(this.$props.form.dustPreventionDescription);
    }

    get isOtherCleaningError(): boolean {
        return this.isOtherCleaningSelected && func.isNullOrEmpty(this.$props.form.cleaningProcedureDescription);
    }

    get isRecordKeepingError(): boolean {
        return func.isNullOrEmpty(this.$props.form.recordKeepingDescription);
    }

    get isProceduresDescription(): boolean {
        return func.isNullOrEmpty(this.$props.form.proceduresDescription);
    }

    get isRadioError(): boolean {
        return func.isNullOrEmpty(this.$props.form.isReturnedMaterialsRecorded)
            || func.isNullOrEmpty(this.$props.form.isUnauthorizedMaterials)
            || func.isNullOrEmpty(this.$props.form.isAcceptanceLogMaintained)
            || func.isNullOrEmpty(this.$props.form.isDocumentsUnauthorizedWaste)
    }   

    get hasErrors(): boolean {
        return this.isMaterialCapacityError ||
            this.isOtherSourcesError ||
            this.isMaterialTransportError ||
            this.isOtherProcessMethodError ||
            this.isEquipmentMachineryError ||
            this.isOtherOdorPreventionError ||
            this.isOtherNoisePreventionError ||
            this.isOtherDustPreventionError ||
            this.isOtherCleaningError ||
            this.isRecordKeepingError ||
            this.isRadioError;
    }
    
    private getIsOtherOptionSelected(data: ISelectItemVueModel[]): boolean {
        let item = data.find(value => value.name.endsWith("*"));
        if (item === undefined || item === null) return false;
        return item.isSelected;
    }

}
